export enum LocalStorageKeys {
  AdvisorLayerMode = 'advisorLayerMode',
  AnnualReportsWigetClosed = 'annual-reports-widget-closed',
  BankIntegrationSelection = 'bank-integration-selection',
  BankStatementUpload = 'bank-statement-upload',
  BillyWelcomeModal = 'billy-welcome-modal',
  ConnectBankBannerDismissed = 'connect-bank-banner-dismissed',
  DashboardEInvoicingBanner = 'dashboard-e-invoicing-banner',
  DashboardEInvoicingDisabledBanner = 'dashboard-e-invoicing-disabled-banner',
  DashboardExternalInvoicesSyncBanner = 'dashboard-external-invoices-sync-banner',
  DashboardPeriodDropdown = 'dashboard-period-dropdown',
  ExpertTrialBalanceHiddenColumns = 'expert-trial-balance-hidden-columns',
  HideBookkeepingHero = 'hide-bookkeeping-hero',
  HideConnectBankOverlay = 'hide-connect-bank-overlay',
  HideDepositInvoiceCurrencyChangeBanner = 'hide-deposit-invoice-currency-change-banner',
  HideInvoiceEditorEInvoicingInfoBanner = 'hideInvoiceEditorEInvoicingInfoBanner',
  HideInvoiceLanguageChangePreviewBanner = 'hideInvoiceLanguageChangePreviewBanner',
  HideSalesReportCustomersExportLimitBanner = 'hideSalesReportCustomersExportLimitBanner',
  HideSalesReportInvoicesExportLimitBanner = 'hideSalesReportInvoicesExportLimitBanner',
  HideSalesReportItemsExportLimitBanner = 'hideSalesReportItemsExportLimitBanner',
  HideExternalInvoicesSyncProgressTopBar = 'hide-external-invoices-sync-progress-top-bar',
  InboxOrganizationId = 'inboxOrganizationId',
  MobileExperienceMessageClosed = 'mobile-experience-message-closed',
  OnboardingFinalized = 'onboarding-finalized',
  OnboardingStepHistory = 'onboarding-step-history',
  RecentProductUnits = 'recent-product-units',
  ReviewEntryDraft = 'review-entry-draft',
  ScoutBannerClosed = 'scout-banner-closed',
  SendInvoiceCopyToUser = 'send-invoice-copy-to-user',
  VatDeclarationsCorrectionBanner = 'vat-declarations-correction-banner',
  VatDeclarationsCorrectionsTabsBadge = 'vat-declarations-corrections-tabs-badge',
  VatDeclarationsPromoBanner = 'vat-declarations-promo-banner',
  VatDeclarationsSubmissionFailedBanner = 'vat-declarations-submission-failed-banner',
}
